import {JsonObject, JsonProperty} from 'json2typescript';

@JsonObject('CloneReferencedProject')
export class CloneReferencedProject {

    @JsonProperty('project_id',Number)
    private readonly projectId:number = 0;

    @JsonProperty('questionnaire_id',Number)
    private readonly questionnaireId:number = 0;

    @JsonProperty('terminal_id',Number)
    private readonly terminalId:number = 0;

    constructor(pId:number,qId:number,tId:number) {
        this.projectId = pId;
        this.questionnaireId = qId;
        this.terminalId = tId;
    }


    getProjectId(): number {
        return this.projectId;
    }

    getQuestionnaireId(): number {
        return this.questionnaireId;
    }

    getTerminalId(): number {
        return this.terminalId;
    }
}
